import { queryOptions } from "@tanstack/react-query";
import { createSetupIntent } from "@/api/billing";
import { queryKeys } from "@/lib/query-keys";
import { getSetupIntentFormKey } from "./setup-intent-form-key";

/**
 * Builds the shared SetupIntent query for one organization's pricing and
 * payment steps. It reuses the organization-scoped session form key, treats
 * cached data as fresh until invalidated, and suppresses focus refetches and
 * automatic retries so they cannot issue background POST requests.
 *
 * @param organizationId - Organization that owns the cache entry and form key.
 * @returns Query options for the shared SetupIntent request.
 */
export function setupIntentQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: queryKeys.billing.setupIntent(organizationId),
    queryFn: () =>
      createSetupIntent(organizationId, getSetupIntentFormKey(organizationId)),
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
